import React, { FC } from 'react';
import { Text, View } from 'react-native';
import { is24HourFormat, scale as initialScale } from '@components/frame';
import { font as initialFont } from '@styles/fonts';
import i18n from 'i18n-js';
import { formatSinceTimeWithDayTranslationCase } from '@helpers';
import Svg from '@styles/icons/svg';
import { IconConfig } from '@components/operatorPanel/interfaces';
import { PanelProps } from '@components/operatorPanel/components/panel';

export interface ContentUnavailableCentralPartProps extends Pick<PanelProps, 'CC' | 'scale' | 'font'> {
  time?: string;
  text?: string;
  title: string;
  iconConfig?: IconConfig;
  titleFont?: keyof typeof initialFont;
  titleColor?: string;
  titleAlreadyTranslated?: boolean;
  textAlreadyTranslated?: boolean;
  titleWidth?: number;
  timeMarginTop?: number;
  timeFont?: keyof typeof initialFont;
}

const ContentUnavailableCentralPart: FC<ContentUnavailableCentralPartProps> = ({
  CC,
  time,
  text,
  iconConfig,
  title,
  titleAlreadyTranslated,
  textAlreadyTranslated,
  titleWidth,
  titleFont = 'Roboto Large Title',
  titleColor = 'Label/Dark/Tertiary',
  timeFont = 'Body Extra Large',
  timeMarginTop = 4,
  scale = initialScale,
  font = initialFont,
}) => {
  return (
    <View style={{ width: '100%', alignItems: 'center' }}>
      <Text style={[font[titleFont], { color: CC(titleColor), textAlign: 'center' }, titleWidth != null && { width: scale(titleWidth) }]}>
        {titleAlreadyTranslated ? title : i18n.t(title)}
      </Text>
      {time && (
        <Text style={[font[timeFont], { color: CC('Label/Dark/Always Light Tertiary'), marginTop: scale(timeMarginTop) }]}>
          {formatSinceTimeWithDayTranslationCase(time, is24HourFormat)}
        </Text>
      )}
      {(text || iconConfig) && (
        <View style={{ marginTop: scale(21), width: '100%', alignItems: 'center', gap: scale(12) }}>
          {iconConfig && <Svg {...iconConfig} />}
          {text && (
            <Text style={[font['Subhead 2'], { color: CC('Label/Light/Always Light Tertiary'), textAlign: 'center', width: scale(360) }]}>
              {textAlreadyTranslated ? text : i18n.t(text)}
            </Text>
          )}
        </View>
      )}
    </View>
  );
};

export { ContentUnavailableCentralPart };
